import React, { useCallback, useMemo, useState } from 'react';
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import ParticipantModal from '../Modals/ParticipantModal';
import DeleteParticipantModal from '../Modals/DeleteParticipantModal';
import { Icons } from '../../../utils/Icons';
import { toSmartTitleCase } from '../../../utils/toSmartTitleCase';

const ParticipantsTab = ({
	participantsList,
	handleParticipantsList
}) => {

	const [dataParticipant, setDataParticipant] = useState(null);
	const [isEdit, setIsEdit] = useState(false);
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);

	const handleClickEdit = useCallback((participant) => {
		setIsEdit(true);
		setDataParticipant(participant);
		handleToggleModal();
	}, []);

	const handleClickDelete = useCallback((participant) => {
		setDataParticipant(participant);
		handleToggleModalDelete();
	}, []);

	function handleToggleModal() {
		setModal(prev => !prev);
	}

	function handleToggleModalDelete() {
		setModalDelete(prev => !prev);
	}

	const handleCreateParticipant = useCallback(() => {
		setIsEdit(false);
		setDataParticipant({});
		handleToggleModal();
	}, []);

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'actions',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					const rowData = cellProps.row.original;
					return (
						<React.Fragment>
							<div className='d-flex justify-content-center'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												title={'Editar'}
												to='#'
												onClick={event => {
													event.preventDefault();
													handleClickEdit(rowData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Eliminar'}
												to='#'
												className='remove-item-btn'
												onClick={event => {
													event.preventDefault();
													handleClickDelete(rowData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ 
				header: 'Nombre',
				accessorKey: 'person.name',
				dataType: 'text',
				size: 'auto',
				Cell: ({ row }) => {
					return (
						<div className='no-nowrap'>{toSmartTitleCase(row.original.person?.name || '-')}</div>
					);
				},
			},
			{
				header: '¿Es Externo?',
				accessorKey: 'external',
				size: 'auto',
				dataType: 'boolean',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='disabled'
							name='disabled'
							disabled
							checked={Boolean(row.original.external)}
						/>
					);
				},
			},
			{ 
				header: 'Empresa o Institución', 
				accessorKey: 'organization', 
				size: 'auto', 
				dataType: 'select',
			},
			{
				header: '¿Es Responsable?',
				accessorKey: 'responsible',
				size: 'auto',
				dataType: 'boolean',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='disabled'
							name='disabled'
							disabled
							checked={Boolean(row.original.responsible)}
						/>
					);
				},
			},
		],
		[handleClickDelete, handleClickEdit]
	);

	return (
		<React.Fragment>
			<Col lg={12}>
				<div className='mt-3 my-4'>
					<ODataGrid
						columns={columns}
						data={participantsList || []}
						customToolbarActions={[
							{
								label: 'Agregar',
								icon: Icons.plus,
								onClick: handleCreateParticipant,
								title: 'Agregar Participantes',
							}
						]}
					/>
				</div>
			</Col>
			<ParticipantModal
				dataParticipant={dataParticipant}
                isOpen={modal}
                isEdit={isEdit}
                handleToggleModal={handleToggleModal}
                participantsList={participantsList}
                handleParticipantsList={handleParticipantsList}
            />
			<DeleteParticipantModal
				dataParticipant={dataParticipant}
                isOpen={modalDelete}
                handleToggleModal={handleToggleModalDelete}
                participantsList={participantsList}
                handleParticipantsList={handleParticipantsList}
            />
		</React.Fragment>
	);
};

export default ParticipantsTab;